<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card outlined>
          <v-card-title>
            <v-icon
              medium
              left>
              library_books
            </v-icon>
            <span class="title">Info</span>
          </v-card-title>
          <v-tabs
            v-model="tabdata"
            :background-color="maincolor"
            centered
            dark
            icons-and-text
            show-arrows>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              List Info
              <v-icon large>library_books</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew">
              Buat Baru
              <v-icon large>library_add</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabdata">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="3">
                        <v-autocomplete
                          v-model="filter.type"
                          :items="listtype"
                          label="Jenis info">
                        </v-autocomplete>
                      </v-col>
                      <v-col cols="12" md="7">
                        <v-text-field
                          v-model="filter.search"
                          append-icon="search"
                          label="Judul"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-btn
                          large
                          block
                          :color="maincolor"
                          class="mt-1 white--text"
                          @click="getBerita">
                          <v-icon left dark>search</v-icon>
                          Cari
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <div class="text-center" v-if="loading.getdata">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-data-table
                          v-if="!loading.getdata"
                          :headers="headers"
                          :items="datalist"
                          :search="filter.search">
                          <template v-slot:[`item.tgl_berita`]="{ item }">
                            {{ item.type_berita === 'event' ? item.tgl_berita + ' ~ ' + item.tgl_end : item.tgl_berita }}
                          </template>
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              @click="editberita(item)"
                              small
                              icon>
                              <v-icon>edit</v-icon>
                            </v-btn>
                            <v-btn
                              @click="deleteberita(item)"
                              small
                              icon>
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-form
                      @submit.prevent="submitAdd"
                      ref="formaddberita"
                      v-model="formadd.valid"
                      lazy-validation>
                      <v-row justify="center" no-gutters>
                        <v-col cols="12" md="11">
                          <v-row>
                            <v-col cols="12" md="3">
                              <v-select
                                :items="listtype"
                                name="typeberita"
                                v-model="addberita.type_berita"
                                label="Jenis info"
                                :rules="[rules.required]">
                              </v-select>
                            </v-col>
                            <v-col cols="12" md="1">
                              <v-select
                                :items="listlang"
                                name="language"
                                v-model="addberita.lang_berita"
                                label="Bahasa"
                                :rules="[rules.required]">
                              </v-select>
                            </v-col>
                            <v-col cols="12" md="8">
                              <v-text-field
                                v-model="addberita.judul_berita"
                                :rules="[rules.required]"
                                label="Judul"
                                name="judul"
                                required>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-textarea
                                name="prev"
                                label="Preview info (Max 200 Karakter)"
                                placeholder="Tuliskan preview info disini..."
                                counter
                                rows="3"
                                v-model="addberita.prev_berita"
                                :rules="[rules.required, rules.textlimit]">
                              </v-textarea>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-file-input
                                v-model="addberita.pic_berita"
                                :rules="rules.files"
                                accept=".png, .jpg, .jpeg"
                                name="fileresume"
                                placeholder="Select file"
                                label="Image Thumbnail (max. 500 Kb)"
                                show-size
                                prepend-icon="mdi-camera">
                              </v-file-input>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <!-- <vue2-tinymce-editor
                                v-model="addberita.isi_berita"
                                :options="{images_upload_url: 'postAcceptor.php'}">
                              </vue2-tinymce-editor> -->
                              <vue-editor
                                v-model="addberita.isi_berita"
                                placeholder="Tuliskan isi info disini..."
                                :rules="[rules.required]">
                              </vue-editor>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="4">
                              <v-menu
                                v-model="datepick.addtglberita"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px">
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-model="addberita.tgl_berita"
                                    :label="addberita.type_berita === 'agenda' ? 'Mulai' : 'Tanggal info'"
                                    v-on="on">
                                  </v-text-field>
                                </template>
                                <v-date-picker
                                  :min="datepick.date"
                                  v-model="addberita.tgl_berita"
                                  @input="updateDate">
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" md="4" v-if="addberita.type_berita === 'agenda'">
                              <v-menu
                                v-model="datepick.addtglevent"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px">
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    v-model="addberita.tgl_end"
                                    label="Berakhir"
                                    v-on="on">
                                  </v-text-field>
                                </template>
                                <v-date-picker
                                  :min="addberita.tgl_berita"
                                  v-model="addberita.tgl_end"
                                  @input="datepick.addtglevent = false">
                                </v-date-picker>
                              </v-menu>
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-select
                                :items="listcategory"
                                name="categoryinfo"
                                v-model="addberita.cat_berita"
                                label="Kategori info"
                                :rules="[rules.required]">
                              </v-select>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" class="text-center">
                              <alertsp :alertdata="alertdata"></alertsp>
                              <v-btn
                                large
                                block
                                :disabled="!formadd.valid"
                                :color="maincolor"
                                dark
                                class="mr-4 mt-5"
                                type="submit">
                                Simpan
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal - update -->
    <v-dialog
      v-model="dmodal.berita"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card v-if="dmodaldata.berita">
        <v-toolbar :color="maincolor" dark class="px-md-5" flat>
          <v-toolbar-title>
            Update data info
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="closeDmodal('berita')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-row justify="center" class="black--text py-5">
            <v-col cols="12" md="11">
              <v-card outlined rounded="lg">
                <v-card-text>
                  <v-form
                    @submit.prevent="submitUpdate"
                    ref="formupdateberita"
                    v-model="formupdate.valid"
                    lazy-validation>
                    <v-row justify="center">
                      <v-col cols="12" md="8">
                        <v-row>
                          <v-col cols="12" md="2">
                            <v-select
                              :items="listlang"
                              name="languageupdate"
                              v-model="dmodaldata.berita.lang_berita"
                              label="Bahasa">
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="10">
                            <v-text-field
                              v-model="dmodaldata.berita.judul_berita"
                              :rules="[rules.required]"
                              label="Judul"
                              name="judul"
                              required>
                            </v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea
                              name="prev"
                              label="Preview info (Max 200 Karakter)"
                              placeholder="Tuliskan preview info disini..."
                              counter
                              rows="3"
                              v-model="dmodaldata.berita.prev_berita"
                              :rules="[rules.required, rules.textlimit]">
                            </v-textarea>
                          </v-col>
                          <v-col cols="12">
                            <vue-editor
                              v-model="dmodaldata.berita.isi_berita"
                              placeholder="Tuliskan isi info disini..."
                              :rules="[rules.required]">
                            </vue-editor>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-menu
                              v-model="datepick.updatetglberita"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="dmodaldata.berita.tgl_berita"
                                  :label="dmodaldata.berita.type_berita === 'event' ? 'Mulai' : 'Tanggal'"
                                  v-on="on">
                                </v-text-field>
                              </template>
                              <v-date-picker
                                v-model="dmodaldata.berita.tgl_berita"
                                @input="updateDateEvent">
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="4" v-if="dmodaldata.berita.type_berita === 'event'">
                            <v-menu
                              v-model="datepick.updatetglevent"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="290px">
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                  v-model="dmodaldata.berita.tgl_end"
                                  label="Berakhir"
                                  v-on="on">
                                </v-text-field>
                              </template>
                              <v-date-picker
                                :min="dmodaldata.berita.tgl_berita"
                                v-model="dmodaldata.berita.tgl_end"
                                @input="datepick.updatetglevent = false">
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-select
                              :items="listcategory"
                              name="categoryupdate"
                              v-model="dmodaldata.berita.cat_berita"
                              label="Kategori info">
                            </v-select>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-select
                              :items="liststatus"
                              name="statusberita"
                              v-model="dmodaldata.berita.status_berita"
                              label="Status">
                            </v-select>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="4">
                        <v-row>
                          <v-col cols="12">
                            <v-img
                              v-if="dmodaldata.berita.pic_berita"
                              :lazy-src="require('../../assets/default.jpg')"
                              :src="api + '/upload/news/' + dmodaldata.berita.pic_berita"
                              contain>
                            </v-img>
                            <v-img
                              v-if="!dmodaldata.berita.pic_berita"
                              :lazy-src="require('../../assets/default.jpg')"
                              :src="require('../../assets/default.jpg')"
                              contain>
                            </v-img>
                          </v-col>
                          <v-col cols="12">
                            <v-file-input
                              v-model="dmodaldata.berita.pic_beritanew"
                              :rules="rules.files"
                              accept=".png, .jpg, .jpeg"
                              name="fileresume"
                              placeholder="Select file"
                              label="Image Thumbnail (max. 500 Kb)"
                              show-size
                              prepend-icon="mdi-camera">
                            </v-file-input>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="12">
                        <v-row>
                          <v-col cols="12" class="text-center">
                            <alertsp :alertdata="alertupdate"></alertsp>
                            <v-btn
                              block
                              large
                              :disabled="loading.update || !formupdate.valid"
                              :loading="loading.update"
                              :color="maincolor"
                              dark
                              type="submit">
                              Simpan
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- delete -->
    <v-dialog
      v-model="dmodal.delberita"
      max-width="450px">
      <v-card v-if="dmodaldata.delberita">
        <v-card-title>
          <span>Hapus data info</span>
          <v-spacer></v-spacer>
          <v-icon
            class="float-right class-cursor"
            color="red"
            @click="dmodal.delberita = false">
            mdi-close-box
          </v-icon>
        </v-card-title>
        <v-card-text>
          <alertsp :alertdata="alertupdate"></alertsp>
          <div class="font-weight-bold">
            Apakah anda yakin menghapus data info? <br>
            <b>{{ dmodaldata.delberita.judul_berita }}</b>
            <!-- <span class="green--text" v-html="msgcopy"></span> -->
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            class="ml-2 mb-3"
            color="error"
            dark
            :loading="loading.remove"
            :disabled="loading.remove"
            @click="confirmRemove(dmodaldata.delberita)">
            Hapus
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';
import { VueEditor } from 'vue2-editor';
import { Vue2TinymceEditor } from 'vue2-tinymce-editor';

export default {
  name: 'Infoadmin',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
      remove: false,
      update: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    listtype: ['berita', 'agenda', 'pengumuman', 'file'],
    listlang: ['id', 'en'],
    listcategory: ['pnb', 'pendidikan', 'penelitian', 'pengabdian', 'kerjasama', 'mahasiswa', 'bali', 'covid', 'pendaftaran', 'pkkmb', 'zi-wbk'],
    listfav: ['tidak', 'ya'],
    filter: {
      search: '',
      type: 'berita',
    },
    headers: [
      { text: 'Judul', value: 'judul_berita' },
      { text: 'Tanggal', value: 'tgl_berita', width: 120 },
      { text: 'Kategori', value: 'cat_berita', width: 100 },
      { text: 'Bahasa', value: 'lang_berita', width: 100 },
      { text: 'Status', value: 'status_berita', width: 100 },
      { text: 'Actions', value: 'action', sortable: false, align: 'center', width: 90 },
    ],
    datalist: [],
    addberita: {
      judul_berita: '',
      prev_berita: '',
      isi_berita: '',
      tgl_berita: '',
      tgl_end: '',
      type_berita: 'berita',
      lang_berita: 'id',
      cat_berita: 'pendidikan',
      pic_berita: null,
      status_berita: 'active',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 8 || 'Min 8 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
      textlimit: (v) => (v) && v.length <= 200 || 'Max 200 characters',
      files: [
        (value) => !value || value.size < 500000 || 'File kurang dari 500 Kb!',
      ],
    },
    tabdata: null,
    dmodal: {
      berita: false,
      delberita: false,
    },
    dmodaldata: {
      berita: null,
      delberita: null,
    },
    datepick: {
      date: new Date().toISOString().substr(0, 10),
      addtglberita: false,
      addtglevent: false,
      updatetglberita: false,
      updatetglevent: false,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getBerita();
    this.addberita.type_berita = this.listtype[0];
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    updateDate() {
      this.datepick.addtglberita = false;
      if (Date.parse(this.addberita.tgl_berita) > Date.parse(this.addberita.tgl_end)) {
        this.addberita.tgl_end = this.addberita.tgl_berita;
      }
    },
    updateDateEvent() {
      this.datepick.updatetglberita = false;
      if (Date.parse(this.dmodaldata.berita.tgl_berita) > Date.parse(this.dmodaldata.berita.tgl_end)) {
        this.dmodaldata.berita.tgl_end = this.dmodaldata.berita.tgl_berita;
      }
    },
    getBerita() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/berita/',
            {
              params: this.filter,
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddberita.validate()) {
        if (this.tokenscr) {
          const dataadd = this.addberita;
          const formData = new FormData();
          // file image
          // formData.append('logo_olga', dataadd.logo_olga);
          // data olga
          formData.append('judul_berita', dataadd.judul_berita);
          formData.append('prev_berita', dataadd.prev_berita);
          formData.append('isi_berita', dataadd.isi_berita);
          formData.append('tgl_berita', dataadd.tgl_berita);
          formData.append('tgl_end', dataadd.tgl_end);
          formData.append('type_berita', dataadd.type_berita);
          formData.append('pic_berita', dataadd.pic_berita);
          formData.append('status_berita', dataadd.status_berita);
          formData.append('cat_berita', dataadd.cat_berita);
          formData.append('lang_berita', dataadd.lang_berita);
          this.axios
            .post(
              this.api + '/api/berita/',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddberita.reset();
                  this.addberita.isi_berita = '';
                  // this.addberita.cat_berita = this.listcategory[0];
                  // this.addberita.lang_berita = this.listlang[0];
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Info "' + resdata.data + '" berhasil ditambahkan!';
                  this.getBerita();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'berita') {
        this.dmodal.berita = false;
      } else {
        this.dmodal.berita = false;
      }
    },
    editberita(item) {
      this.dmodal.berita = true;
      this.alertupdate.show = false;
      this.dmodaldata.berita = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdateberita.validate()) {
        if (this.tokenscr) {
          this.loading.update = true;
          const dataadd = this.dmodaldata.berita;
          const formData = new FormData();
          // file
          // formData.append('logo_olganew', dataadd.logo_olganew);
          // data
          // console.log(dataadd);
          formData.append('status_berita', dataadd.status_berita);
          formData.append('prev_berita', dataadd.prev_berita);
          formData.append('isi_berita', dataadd.isi_berita);
          formData.append('judul_berita', dataadd.judul_berita);
          formData.append('tgl_berita', dataadd.tgl_berita);
          formData.append('tgl_end', dataadd.tgl_end);
          formData.append('id_berita', dataadd.id_berita);
          formData.append('pic_berita', dataadd.pic_berita);
          formData.append('pic_beritanew', dataadd.pic_beritanew);
          formData.append('cat_berita', dataadd.cat_berita);
          formData.append('lang_berita', dataadd.lang_berita);
          this.axios
            .post(
              this.api + '/api/berita/update',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = '"' + this.dmodaldata.berita.judul_berita + '" berhasil diubah!';
                  this.getBerita();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
              this.loading.update = false;
            })
            .catch((error) => {
              this.loading.update = false;
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.loading.update = false;
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
    deleteberita(item) {
      this.dmodal.delberita = true;
      this.alertupdate.show = false;
      this.dmodaldata.delberita = JSON.parse(JSON.stringify(item));
    },
    confirmRemove(item) {
      // console.log(item);
      this.alertupdate.show = false;
      if (this.tokenscr && item) {
        // console.log(item);
        this.loading.remove = true;
        this.axios
          .delete(
            this.api + '/api/berita/' + item.id_berita,
            {
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              // console.log(resdata);
              if (resdata.error === false) {
                this.dmodal.delberita = false;
                this.dmodaldata.delberita = null;
                this.getBerita();
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = resdata.message;
              }
            } else {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            }
            this.loading.remove = false;
          })
          .catch((error) => {
            console.log(error);
            this.alertupdate.show = true;
            this.alertupdate.type = 'error';
            this.alertupdate.text = 'Internal services error!';
            this.loading.remove = false;
          });
      } else {
        this.alertupdate.show = true;
        this.alertupdate.type = 'error';
        this.alertupdate.text = 'Invalid token, please refresh first!';
      }
    },
  },
  components: {
    Alertsp,
    VueEditor,
    Vue2TinymceEditor,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
